import { Component } from '@angular/core';

@Component({
  selector: 'app-audit-report-wrapper',
  templateUrl: './audit-report-wrapper.component.html',
  styleUrls: ['./audit-report-wrapper.component.css'],
  standalone: false,
})
export class AuditReportWrapperComponent {
  constructor() {}
}
